<template lang="pug">
  WtEntityTable.members-table(
    :type="type"
    :title="title"
    :loading="loading"
    :data="membersData"
    :staged-entities-data="stagedEntitiesData"
    :pagination-object="mode === 'api' ? _.get(membersResponseObject, 'pagination', null) : staticPaginationObject"
    :fetch-action="mode === 'api' ? fetchAction : staticFetchAction"
    :show-title="showTitle"
    default-sort-field="username"
    :enable-search="enableSearch"
    @search="$emit('search', $event)"
    :search-fields="searchFields"
    :enable-remove="enableRemove"
    :enable-add="enableAdd"
    :includeByType="includeByType"
    @remove="removeMember($event)"
    @add="addMember($event)"
    :empty-message="emptyMessage"
    searchPlaceholder="Search by username"
  )
    BTableColumn(field="username" label="Username" sortable v-slot="column")
      WtTableCellLongText(:text="column.row.username")
    BTableColumn(
      v-if="$auth.user() ? $auth.user().isAdmin : false"
      field="email"
      label="Email"
      centered sortable
      v-slot="column"
      is-relative
    )
      WtTableCellLongText(:text="column.row.email")
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import tablePropsMixin from "@/mixins/tablePropsMixin";
import WtEntityTable from "@@/WtEntityTable/WtEntityTable";
import WtTableCellLongText from "@@/WtTableCellLongText/WtTableCellLongText";

const STATIC = "static";
const API = "api";
const RECEIVER = "receiver";

export default {
  name: "MembersTable",

  components: { WtEntityTable, WtTableCellLongText },

  mixins: [tablePropsMixin],

  props: {
    type: {
      type: String,
      default: "challenge"
    },
    /**
     * set as `api` to fetch members to populate table, set as `receiver`
     * to allow members to be added to table
     */
    mode: {
      type: String,
      default: "api",
      validator(mode) {
        return [STATIC, API, RECEIVER].indexOf(mode) !== -1;
      }
    },

    title: {
      type: String,
      default: "Member list:"
    },

    stagedEntitiesData: {
      type: Array,
      default: () => []
    },

    staticMembersData: {
      type: Array,
      default: () => []
    },

    staticPaginationObject: {
      type: Object,
      default: null
    },

    staticFetchAction: {
      type: Function,
      default: () => 1
    },

    includeByType: {
      type: String,
      default: "invite"
    },

    notInTeam: {
      type: Boolean,
      default: false
    },

    notInChallengeId: {
      type: Number,
      default: null
    },

    inOrganizationId: {
      type: Number,
      default: null
    }
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters("program", ["membersResponseObject", "membersLoaded"]),
    ...mapGetters("challengeBuilder", ["stagedMembers"]),

    membersData() {
      if (this.mode === STATIC) {
        return this.staticMembersData;
      } else if (this.mode === API) {
        return this._.get(this.membersResponseObject, "data", []);
      } else {
        return this.stagedMembers;
      }
    }
  },
  watch: {
    inOrganizationId() {
      if (this.mode === API) {
        this.fetchAction();
      }
    }
  },

  async mounted() {
    if (this.mode === API) {
      this.fetchAction();
    }
  },

  methods: {
    ...mapActions("challengeBuilder", ["unstageMember", "stageMember"]),
    ...mapActions("program", ["fetchMembers"]),

    async fetchAction(payload) {
      await this.fetchMembers({
        ...payload,
        programId: this.$auth.user().programId,
        perPage: 10,
        notInTeam: this.notInTeam,
        notInChallengeId: this.notInChallengeId,
        inOrganizationId: this.inOrganizationId
      });
    },

    addMember($event) {
      if (this.type === "challenge") {
        return this.stageMember($event);
      }
      if (this.type === "team") {
        // TODO refactor to use stageTeamMember
        return this.stageMember($event);
      }
    },

    removeMember($event) {
      if (this.type === "challenge") {
        return this.unstageMember($event);
      }
      if (this.type === "team") {
        // TODO refactor to use unstageTeamMember
        return this.unstageMember($event);
      }
    }
  }
};
</script>
